import { Button } from "@mui/material"

const AppButton = Button

export default AppButton
